module.exports = {"helmetTitle":"VeloeTag bloqueado","title":"Sua VeloeTag foi bloqueado","infoSubtitle":"Seu pedido já está com a gente para análise. Em breve, vamos entrar em contato para você pedir uma nova VeloeTag. Enquanto isso, guarde o número do protocolo:","protocol":"1234029809","date":"Salvo em 10/10/2017 às 19:30"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/BlockIdentifierSuccess/data.json
// module id = 1797
// module chunks = 0